/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, OnInit, signal} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';

import template from './creative-from-line-item-copy-modal.component.html';
import {Uuid} from '../../components/util/uuid';
import {deferSignalStateWrite} from '../common/util/template-state';
import {CreativeApiService} from '../creative/creative-api.service';
import {firstValueFrom} from 'rxjs';

@Component({
  standalone: false,
  selector: 'adn-creative-from-line-item-copy-modal',
  template
})
export class CreativeFromLineItemCopyModalComponent implements OnInit {
  destinationLineItem: any;
  destinationLineItemName = 'This Line Item';
  specifiedAdvertiser: any;
  preselectCurrentLineItem = false;
  perms: any = {};
  onClosed: () => void;

  lineItem: any;
  lineItemName = 'This Line Item';
  newName = '{currentName} (Copy)';
  creativeFilterText = '';
  readonly creatives = signal<any[] | undefined>(undefined);
  readonly loadingCreatives = signal(false);
  disabled = false;

  constructor(
    public bsModalRef: BsModalRef,
    private readonly creativeApi: CreativeApiService
  ) {
  }

  ngOnInit(): void {
    this.lineItemName = this.destinationLineItemName || this.destinationLineItem?.name || 'This Line Item';
    if (this.preselectCurrentLineItem && this.destinationLineItem) {
      this.lineItem = this.destinationLineItem;
      this.onSelect();
    }
  }

  get creativesResolved(): boolean {
    return this.creatives() !== undefined && !this.loadingCreatives();
  }

  get filteredCreatives(): any[] {
    const filterText = (this.creativeFilterText || '').toLowerCase();
    return (this.creatives() || []).filter((creative) => {
      return !filterText || _.get(creative, 'name', '').toLowerCase().indexOf(filterText) > -1;
    });
  }

  hasPreventsAdServing(warnings: any[]): boolean {
    return !!_.find(warnings || [], (warning) => warning.preventsAdServing);
  }

  onSelect(): void {
    const lineItemId = _.get(this.lineItem, 'id');
    if (!lineItemId) {
      return;
    }
    this.loadingCreatives.set(true);
    this.creatives.set(undefined);
    this.creativeApi.listOptions({lineItem: lineItemId, concise: true, pageSize: 201}).subscribe((page: any) => {
      deferSignalStateWrite(() => {
        this.creatives.set(page.results);
        this.loadingCreatives.set(false);
      });
    });
  }

  copyCreative(creative: any): void {
    creative.nameNeeded = false;
    if (!this.newName) {
      creative.nameNeeded = true;
      return;
    }

    creative.copyDone = false;
    creative.copyError = false;
    creative.thinking = true;

    const copyPayload = _.cloneDeep(creative);
    copyPayload.name = this.newName.replace('{currentName}', creative.name);
    const newId = Uuid.generate();
    firstValueFrom(this.creativeApi.copyCreative(copyPayload, {
      lineItemId: this.destinationLineItem?.id,
      creativeId: newId
    })).then(() => {
      deferSignalStateWrite(() => {
        creative.copyDone = true;
        creative.thinking = false;
        this.creatives.update((items) => items ? [...items] : items);
      });
    }, () => {
      deferSignalStateWrite(() => {
        creative.copyError = true;
        creative.thinking = false;
        this.creatives.update((items) => items ? [...items] : items);
      });
    });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
